import axios from "axios";
import { toast } from "react-toastify";
import { getToken, deleteToken } from "./storage";
import { loginPathFor } from "../utils/authRedirect";

// REACT_APP_API_URL points a local dev build elsewhere; builds without it use
// production.
const BASE_URL =
  process.env.REACT_APP_API_URL || "https://tarbaa-pro.apis.just2labs.com";

const instance = axios.create({
  baseURL: BASE_URL,
  // Tag every web request so the backend can enforce premium gates for
  // non-subscribers on web (the mobile app doesn't send this — app-side
  // backend enforcement comes later).
  headers: { "X-Client-Platform": "web" },
});

// Attach the JWT bearer token to every request (mirrors the mobile app's
// request interceptor). Public endpoints simply ignore it.
instance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 the token is missing/expired/invalid — clear it and bounce to login.
// Bad-credentials on login/register return 400 (not 401), so this won't fire
// during sign-in. Guard against redirect loops on the auth pages themselves.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      deleteToken();
      const path = window.location.pathname;
      if (path !== "/login" && path !== "/register") {
        // Make session expiry visible instead of a silent bounce to /login.
        toast.info("انتهت الجلسة. الرجاء تسجيل الدخول من جديد.");
        // Come back to the same page after signing in again.
        const back = path + window.location.search;
        setTimeout(() => {
          window.location.href = loginPathFor(back);
        }, 1200);
      }
    }
    return Promise.reject(error);
  },
);

export { BASE_URL, instance };
